import React from 'react';

export const IndeterminateSVG: React.FC<React.SVGProps<SVGSVGElement>> = (props?: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3 0.75H13C14.2426 0.75 15.25 1.75736 15.25 3V13C15.25 14.2426 14.2426 15.25 13 15.25H3C1.75736 15.25 0.75 14.2426 0.75 13V3C0.75 1.75736 1.75736 0.75 3 0.75Z"
        fill="#4B68EF"
        stroke="#4B68EF"
        strokeWidth="1.5"
      />
      <path d="M3 7.5L13 7.5" stroke="white" strokeLinecap="round" />
    </svg>
  );
};
